// @flow
import React, { Component } from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'react-fast-compare';
import ItemCardContainer from './ItemCardContainer';
import styles from './ItemGrid.module.scss';

type Props = {
    allowBidding: boolean,
    cardViewModels: any[],
    className: string,
    hideLotNumbers: boolean,
    hideSeller: boolean,
    itemCardClass: string,
    itemCardModifierCheckFunction: Function,
    itemCardModifierClass: string,
    noPubNub?: boolean,
    openAbsenteeBidModal?: Function,
    openRetractBidModal?: Function,
    openSendSellerMessageModal?: Function,
    showBanner: boolean,
    showBidStatusOnCards: boolean,
    showCtaOnCards: boolean,
    showDate: boolean,
    showEstimate?: boolean,
    showImageWithHover: boolean,
    trackClick?: Function,
};

export default class ItemGrid extends Component<Props> {
    static defaultProps = {
        allowBidding: false,
        cardViewModels: [],
        className: '',
        hideLotNumbers: false,
        hideSeller: false,
        itemCardClass: '',
        itemCardModifierCheckFunction: () => false,
        itemCardModifierClass: '',
        noPubNub: false,
        showBanner: false,
        showBidStatusOnCards: false,
        showCtaOnCards: false,
        showDate: true,
        showImageWithHover: false,
    };

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    buildItemCards = (card: any, index: number) => {
        const {
            allowBidding,
            cardViewModels,
            hideLotNumbers,
            hideSeller,
            itemCardClass,
            itemCardModifierCheckFunction,
            itemCardModifierClass,
            noPubNub,
            openAbsenteeBidModal,
            openRetractBidModal,
            openSendSellerMessageModal,
            showBanner,
            showBidStatusOnCards,
            showCtaOnCards,
            showDate,
            showEstimate,
            showImageWithHover,
            trackClick,
        } = this.props;

        const className = classNames(
            styles.card,
            itemCardClass,
            Boolean(itemCardModifierCheckFunction(card)) && itemCardModifierClass
        );
        const lastItemIndex = cardViewModels.length - 1;

        const itemCardProps: any = {
            allowBidding,
            className: styles.cardInner,
            hideLotNumbers,
            hideSeller,
            key: index,
            last: index === lastItemIndex,
            noPubNub,
            openAbsenteeBidModal,
            openRetractBidModal,
            openSendSellerMessageModal,
            showBanner,
            showBidStatus: showBidStatusOnCards,
            showCta: showCtaOnCards,
            showDate: showDate,
            showEstimate,
            showImageWithHover,
        };
        if (card && !isEmpty(card) && !isEmpty(card.item)) {
            itemCardProps.cardViewModel = card;
        }
        if (trackClick) {
            itemCardProps.trackClick = () => trackClick(card.item.itemId, card.index);
        }
        return (
            <div className={className} key={index}>
                <ItemCardContainer {...itemCardProps} />
            </div>
        );
    };

    render() {
        const { cardViewModels, className } = this.props;
        const cardViews = cardViewModels.map(this.buildItemCards);
        const classes = classNames(styles['item-grid'], className);
        return <div className={classes}>{cardViews}</div>;
    }
}
